import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { ConceptoPagoRealizadoList } from "./conceptos/list";
import { convertirPagoDesglose } from "app/logic/operativa/pago";

type Entity = models.PagoRealizadoDesgloseFeriaModel;

export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void> | void;
    /**Total a pagar, la suma de los importes del usuario debe de ser igual a este importe  */
    importeAPagar: number;
    sugerirCredito: boolean;
    cliente: models.ClienteCreditoDto | null;
}



/**Muestra la feria o si falta dinero */
class FeriaFalta extends React.PureComponent<{ value: models.PagoRealizadoDesgloseFeriaResult }> {
    render() {
        const value = this.props.value;
        return (
            <div>
                <h3>
                    {
                        value.Falta > 0 ?
                            <span className="label label-danger">
                                Falta: {kea.formatCurrency(value.Falta)}
                            </span> :
                            <span className="label label-success">
                                Cambio: {kea.formatCurrency(value.Feria)}
                            </span>
                    }
                </h3>
            </div>
        )
    }
}

/**
* Componente para editar un Entity
*/
export class PagoDesgloseComponent extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    importeAPagar = (props: Props) => props.importeAPagar;
    pagoConvertido = createSelectorRx(this.value, this.importeAPagar, (val, aPagar) => convertirPagoDesglose(val, aPagar));

    errors = createSelectorRx(this.value, this.pagoConvertido, (value, conv) => {
        const ret: validation.Result<Entity> = {
            Conceptos: conv.error == "feriaMayorEfectivo" ? "La feria del pago no debe de ser mayor al importe en efectivo" : undefined,
            ImporteEfectivoAntesFeria: conv.error == "insuficiente" ? "Insuficiente" : undefined,
        };
        return ret;
    });
    getField = formfields(() => this.props, () => this.errors(this.props));

    private onEstablecerFaltante = async () => {
        const falta = this.pagoConvertido(this.props).resultado.Falta;
        this.props.onChange({ ... this.props.value, ImporteEfectivoAntesFeria: falta });
    }

    private onEstablecerTodo = async () => {
        const total = this.props.importeAPagar;
        if (this.props.value.Conceptos.length == 0 || await kea.yesno("¿Borrar todos los conceptos?")) {
            this.props.onChange({ ... this.props.value, ImporteEfectivoAntesFeria: total, Conceptos: [] });
        }
    }

    render() {
        const { value } = this.props;
        const getField = this.getField;

        const Text = getField(kea.Text);
        const Check = getField(kea.Checkbox);
        const Number = getField(kea.Number);

        const Conceptos = getField(ConceptoPagoRealizadoList);
        const convertido = this.pagoConvertido(this.props);
        return (
            <div>
                {
                    this.props.sugerirCredito && this.props.cliente &&
                    <div className="alert alert-warning">
                        <label>
                            <i className={fa("bell")} />
                            Crédito disponible
                        </label>
                        <p>
                            Al cliente <b>{this.props.cliente.Nombre}</b> le restan <b>{kea.formatCurrency(this.props.cliente.CreditoRestante)}</b> de crédito.
                        </p>
                    </div>
                }

                {kea.autogrid(4, [
                    <Number field="ImporteEfectivoAntesFeria" label="Efectivo" addon={<i className={fa("money")} />} format="currency" />,
                    <FeriaFalta value={convertido.resultado} />,
                    <div className="btn-group pull-right">
                        <kea.Button onClick={this.onEstablecerFaltante}>
                            Faltante como efectivo
                        </kea.Button>
                        <kea.Button onClick={this.onEstablecerTodo}>
                            Todo como efectivo
                        </kea.Button>
                    </div>
                ])}

                <Conceptos field="Conceptos" total={this.props.importeAPagar} faltan={convertido.resultado.Falta} />
            </div>);
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/pago/views/desglose/index.tsx